module.exports = __webpack_public_path__ + "img/eduloc360_background.82c4b839.png";